
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "50px",
    "height": "50px",
    "viewBox": "0 0 50 50",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "关闭"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "配置",
            "transform": "translate(-1004.000000, -703.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "编组-11",
                "transform": "translate(640.000000, 547.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "编组-12"
                  },
                  "children": [
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "反馈:6/模态框:7/表格:7"
                      },
                      "children": [
                        {
                          "tag": "g",
                          "attrsMap": {
                            "id": "反馈:6/模态框/表格"
                          },
                          "children": [
                            {
                              "tag": "g",
                              "attrsMap": {
                                "id": "反馈/弹窗/模态框/表格"
                              },
                              "children": [
                                {
                                  "tag": "g",
                                  "attrsMap": {
                                    "id": "编组-5备份-7",
                                    "transform": "translate(334.000000, 126.000000)"
                                  },
                                  "children": [
                                    {
                                      "tag": "g",
                                      "attrsMap": {
                                        "id": "关闭",
                                        "transform": "translate(30.000000, 30.000000)"
                                      },
                                      "children": [
                                        {
                                          "tag": "circle",
                                          "attrsMap": {
                                            "id": "椭圆形",
                                            "fill": "#F9E8E8",
                                            "cx": "25",
                                            "cy": "25",
                                            "r": "25"
                                          }
                                        },
                                        {
                                          "tag": "g",
                                          "attrsMap": {
                                            "transform": "translate(14.705882, 14.705882)",
                                            "fill": "#E94848",
                                            "fill-rule": "nonzero",
                                            "id": "形状结合"
                                          },
                                          "children": [
                                            {
                                              "tag": "path",
                                              "attrsMap": {
                                                "d": "M2.80471163,0.474035768 L10.791,8.461 L18.7639158,0.473924643 C19.3959635,-0.120804321 20.3429415,-0.155788378 20.979106,0.368972473 L21.0945917,0.473924643 C21.7266394,1.14531789 21.7266394,2.17215462 21.0945917,2.80405414 L21.0945917,2.80405414 L13.113,10.783 L21.0945917,18.7639158 C21.7266394,19.3959635 21.7266394,20.423041 21.0945917,21.0945917 C20.462544,21.7266394 19.3959635,21.7266394 18.7639158,21.0945917 L10.782,13.113 L2.80471163,21.0896466 C2.20984321,21.6843756 1.23005994,21.7193597 0.589907426,21.227525 L0.474035768,21.1291404 C-0.158011923,20.4577471 -0.158011923,19.4309104 0.474035768,18.7990109 L0.474035768,18.7990109 L8.463,10.794 L0.474035768,2.80471163 C-0.158011923,2.17266394 -0.158011923,1.14558644 0.474035768,0.474035768 C1.10608346,-0.158011923 2.13316096,-0.158011923 2.80471163,0.474035768 Z"
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  